import { API_PREFIX } from "./api.constants";

export const MESSAGING_ENDPOINTS = {
  THREADS: `${API_PREFIX}/messages/threads`,
  THREAD_MESSAGES: (threadId: number | string) =>
    `${API_PREFIX}/messages/threads/${threadId}/messages`,
  THREAD_READ: (threadId: number | string) =>
    `${API_PREFIX}/messages/threads/${threadId}/read`,
  UNREAD_COUNT: `${API_PREFIX}/messages/unread-count`,
  ATTACHMENT: (messageId: number | string) =>
    `${API_PREFIX}/messages/attachments/${messageId}`,
};
